import React, { useEffect, useState } from "react";
import axiosInstance from "../helper/axios";
import Trans from "../helper/Trans";
import DataLoading from "./DataLoading";
import { notify } from "../helper/Helper";
import Modal from "react-modal";

const attApi = axiosInstance;
function UpdateProfilePicture(props) {
  const [loading, setLoading] = useState(false);
  const [colName, setColName] = useState("Image");
  const [dp, setDp] = useState("/imgs/face.png");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [errors, setErrors] = useState({ app_response_form: "" });
  const [reqCols] = useState(["img"]);
  const [formData, setFormData] = useState({});
  const [formMeta, setFormMeta] = useState({});
  const onImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      const { name } = e.target;
      if (name === "img") {
        setDp((window.URL || window.webkitURL).createObjectURL(img));
      }

      setFormData({
        ...formData,
        [name]: img,
      });
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  function saveData(e) {
    const newErrors = {};

    reqCols.forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = `${formMeta[key]} cannot be blank.`;
        // console.log(formMeta[key]);
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    setLoading(true);
    var formData2 = new FormData();
    formData2.append(`PersonalPicture[id]`, formData['id']);
    formData2.append(`PersonalPicture[img]`, formData['img']);

    attApi
      .post("/update-picture", formData2, {})
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === false) {
            setErrors(res.data.errors);
            notify("Error Validating the Form", "error");
          } else {
            props.refreshAppData();
            notify(res.data.message, "success");
            props.setOpenPictureModal(false);
          }
        } else {
          notify(res.data.message, "error");
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Error Validating the Form", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    if (props.id !== "") {
      attApi.get("get-profile-picture").then((response) => {
        setFormData(response.data.data);
        setDp(
          response.data.data.img === ""
            ? "/imgs/face.png"
            : process.env.REACT_APP_BACKEND_URL2 + response.data.data.img
        );
      });
    }
  }, [props.id]);
  return (
    <div className="mt-3">
      <img
        src={dp}
        height="150px"
        width="150px"
        style={{
          borderRadius: "150px",
          objectFit: "contain",
          margin: "auto",
        }}
        className={`thumbnail mb-3 ${errors.img ? "border border-danger" : ""}`}
        alt="DP"
      />
      <div className="form-group">
        <label className="control-label" htmlFor="img">
          Image
        </label>
        <span style={{ color: "red", marginRight: 4, marginLeft: 10 }}>*</span>
        <input
          type="file"
          id="img"
          name="img"
          accept="image/png, image/jpeg, image/jpg"
          onChange={onImageChange}
          className={` ${errors["img"] ? "is-invalid" : ""}`}
        />
        <div className="invalid-feedback">{errors["img"]}</div>
        <p className="mt-3 text-info">
          Please upload recent not more than six month old passport size
          photograph having blue background. Click{" "}
          <b>
            <span role="button" onClick={() => openModal()}>
              Here
            </span>
          </b>{" "}
          to view accepted image samples
        </p>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Image Modal"
          className="Modal"
          overlayClassName="Overlay"
        >
          <img src="/imgs/sample.jpeg" alt="Guidline" className="modal-image" />
          <br />
          <button
            onClick={closeModal}
            className="btn btn-primary mt-3 text-center"
          >
            Close
          </button>
        </Modal>
      </div>

      {loading ? (
        <DataLoading />
      ) : (
        <>
          <button className="btn btn-primary" onClick={saveData}>
            {Trans("Update")}
          </button>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              props.setOpenPictureModal(false);
            }}
          >
            {Trans("Close")}
          </button>
        </>
      )}
    </div>
  );
}

export default UpdateProfilePicture;
